import { toastError } from "../stores/ui";

let csrfToken = "";

const silentErrorPaths = ["/api/auth/me", "/api/auth/csrf", "/api/settings/public", "/api/search"];

async function ensureCsrf() {
  if (csrfToken) return csrfToken;
  const response = await fetch("/api/auth/csrf", { credentials: "include" });
  const data = (await response.json()) as { csrfToken: string };
  csrfToken = data.csrfToken;
  return csrfToken;
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = (options.method ?? "GET").toUpperCase();
  const headers = new Headers(options.headers);
  if (!headers.has("Content-Type") && options.body) {
    headers.set("Content-Type", "application/json");
  }
  if (method !== "GET" && method !== "HEAD") {
    headers.set("x-csrf-token", await ensureCsrf());
  }
  const response = await fetch(path, {
    ...options,
    headers,
    credentials: "include",
  });
  if (response.status === 204) return undefined as T;
  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    if (!response.ok) {
      const message = "Request failed";
      if (!silentErrorPaths.some((item) => path.startsWith(item))) {
        toastError("Something went wrong", message);
      }
      throw new Error(message);
    }
    return (await response.text()) as T;
  }
  const data = await response.json();
  if (!response.ok) {
    if (response.status === 403) refreshCsrf();
    const message = (data as { error?: string }).error ?? "Request failed";
    if (!silentErrorPaths.some((item) => path.startsWith(item))) {
      toastError("Something went wrong", message);
    }
    throw new Error(message);
  }
  return data as T;
}

export function refreshCsrf() {
  csrfToken = "";
}
